import React from 'react';
import { IconButton, Icon } from '@monash/portal-react';
import c from './page-item.module.scss';

const PageItem = ({ id, pageName, setEditedId }) => {
  return (
    <div className={c.pageItem}>
      {pageName}
      <div className={c.controls}>
        <IconButton
          icon={Icon.DotsHorizontal}
          ariaLabel={`Open ${pageName} menu`}
          onClick={() => setEditedId(id)}
        />
      </div>
    </div>
  );
};

export default PageItem;
